import AffiliatedRestaurants from './AffiliatedRestaurants';

export default AffiliatedRestaurants;
